module.exports = {
  "beta_cerrada.name": {
    en: "Guest",
    es: "Invitado",
  },
  "beta_cerrada.description": {
    en: "Guest Plan Subscription",
    es: "Suscripción al Plan Invitado",
  },
  "app_sumo.name": {
    en: "App Sumo",
    es: "App Sumo",
  },
  "app_sumo.description": {
    en: "App Sumo Subscription",
    es: "Suscripción a través de App Sumo",
  },
  "beginner.name": {
    en: "Beginner",
    es: "Beginner",
  },
  "beginner.trial.name": {
    en: "Beginner Plan (Trial)",
    es: "Plan Beginner (Trial)",
  },
  "beginner.monthly.name": {
    en: "Beginner Plan (Monthly)",
    es: "Plan Beginner (Mensual)",
  },
  "beginner.yearly.name": {
    en: "Beginner Plan (Yearly)",
    es: "Plan Beginner (Anual)",
  },
  "advanced.name": {
    en: "Advanced",
    es: "Advanced",
  },
  "advanced.trial.name": {
    en: "Advanced Plan (Trial)",
    es: "Plan Advanced (Trial)",
  },
  "advanced.monthly.name": {
    en: "Advanced Plan (Monthly)",
    es: "Plan Advanced (Mensual)",
  },
  "advanced.yearly.name": {
    en: "Advanced Plan (Yearly)",
    es: "Plan Advanced (Anual)",
  },
  "ninja.name": {
    en: "Ninja",
    es: "Ninja",
  },
  "ninja.trial.name": {
    en: "Ninja Plan (Trial)",
    es: "Plan Ninja (Trial)",
  },
  "ninja.monthly.name": {
    en: "Ninja Plan (Monthly)",
    es: "Plan Ninja (Mensual)",
  },
  "ninja.yearly.name": {
    en: "Ninja Plan (Yearly)",
    es: "Plan Ninja (Anual)",
  },
  "packageBranding.name": {
    en: "Pack Branding",
    es: "Branding Pack",
  },
  "packageBranding.monthly.name": {
    en: "Branding Pack Monthly",
    es: "Pack Branding Mensual",
  },
  "packageBranding.yearly.name": {
    en: "Branding Pack Yearly",
    es: "Pack Branding Anual",
  },
  "beginner.usersText": {
    en: "One user",
    es: "Un solo usuario",
  },
  "beginner.featureText": {
    en: "For freelancers who want to create professional and impressive proposals.",
    es: "Para autónomos y freelancers que quieren crear presupuestos profesionales.",
  },
  "advanced.usersText": {
    en: "One user",
    es: "Un solo usuario",
  },
  "advanced.featureText": {
    en: "For businesses that want to improve their sales and save management time.",
    es: "Para PYMES asentadas que quieran automatizar sus procesos administrativos y ahorrar tiempo de gestión.",
  },
  "ninja.usersText": {
    en: "One user",
    es: "Un solo usuario",
  },
  "ninja.featureText": {
    en: "Tailored for companies and teams with a large yearly volume of proposals.",
    es: "Pensado para empresas y equipos con gran volumen de presupuestos al año.",
  },
};
